import { applyPageSeo } from './apply-page-seo';
import { getStaticRouteSeo } from './route-seo-config';

/**
 * Apply SEO for the current vue-router route (static config only).
 * Dynamic pages (e.g. course detail) should call applyPageSeo after data loads.
 */
export function applyRouteSeo(route) {
    const config = getStaticRouteSeo(route);
    if (config) {
        applyPageSeo(config);
    }
}

export { applyPageSeo } from './apply-page-seo';
export { buildCoursePageSeo } from './route-seo-config';
